import {
  ClassHandle,
  ProductProperties as EngineProductProperties,
} from "@imi-ernd-be/hyselect-engine";
import { assert } from "radashi";
import { toArray } from "../vector";

export type ProductProperties = Record<
  keyof Omit<EngineProductProperties, keyof ClassHandle>,
  string[]
>;

export function buildProductProperties(
  productProperties: EngineProductProperties | null,
): ProductProperties {
  assert(productProperties, "productProperties must not be null");
  return {
    actuatorProperties: toArray(productProperties.actuatorProperties).map(
      String,
    ),
    measuringValveProperties: toArray(
      productProperties.measuringValveProperties,
    ).map(String),
    outputProperties: toArray(productProperties.outputProperties).map(String),
    properties: toArray(productProperties.properties).map(String),
    sensorProperties: toArray(productProperties.sensorProperties).map(String),
  };
}
